import React from 'react';

import { mediaSizes } from '~src/styles/media-templates';

import { getDisplayName } from './utils';

export interface FormHocProps {
  setInput(input: HTMLInputElement | HTMLTextAreaElement | null): void;
}

export function formHoc<P extends object>(WrappedComponent: React.ComponentType<P & FormHocProps>) {
  class SelectFirstInput extends React.Component<P> {
    input: HTMLInputElement | HTMLTextAreaElement | null;
    displayName: string;

    // WARNING something is *very* fishy about this constructor.
    // debugger shows that this.input is in fact initially *undefined* or *{}*
    // but if I try to make that explicit, it feels like all the Form component typing unravels, so keep it like it is
    constructor(props: P, input: HTMLInputElement) {
      super(props);
      this.input = input;
      this.displayName = `SelectFirstInput(${getDisplayName(WrappedComponent)})`;
    }

    componentDidMount() {
      this.setFocus();
    }

    setInput = (input: HTMLInputElement | HTMLTextAreaElement | null) => {
      this.input = input;
      this.setFocus();
    };

    setFocus = () => {
      if (this.input && this.input.select && window.innerWidth > mediaSizes.tablet) {
        this.input.select();
      }
    };

    render() {
      return <WrappedComponent setInput={this.setInput} {...this.props} />;
    }
  }

  return SelectFirstInput;
}
